import { render, staticRenderFns } from "./DocumentsCreateModal.vue?vue&type=template&id=9bd16b78&scoped=true&"
import script from "./DocumentsCreateModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsCreateModal.vue?vue&type=style&index=0&id=9bd16b78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd16b78",
  null
  
)

export default component.exports